<script>
  import { billingEnumMixins } from '@/mixins/billingEnumMixins';
  import { financeInfoMixins } from '@/mixins/financeInfoMixins';
  import { isNotBlank } from 'utils/string';
  import {
    addAdvHedgeApp,
    advPaymentAutoReceiptProcess,
    auditAdvHedgeAppStatus,
    getAdvHedgeAppPreviewData,
  } from 'api/billing/advertiser/advHedgeApplicationAPI';
  import { isArrayBlank } from 'utils/array';

  const defaultFormData = {
    advHedgeAppNumber: null,
    recordDateRange: [],
    affHedgeAppNumberList: [],
    advReceiptClaimNumberList: [],
    advCompanyPlatform: null,
    advEntity: null,
    hyperTapEntityId: null,
    receiptStatus: null,
    remark: null,
    advHedgeAmount: null,
    applyHedgeAmount: null,
    auditRemark: null,
  };

  const defaultPreviewData = {
    totalAdvConfirmedAmount: null,
    totalAdvCoverAmount: null,
    totalAdvConversion: null,
    totalAdvDeductionAmount: null,
    totalAdvRevenue: null,
    checkMessage: null,
    affHedgeAppItemList: [],
    advPreReceiptAppItemList: [],
  };

  export default {
    name: 'AdvHedgeAppBaseForm',
    mixins: [billingEnumMixins, financeInfoMixins],
    props: {
      dialogType: {
        type: String,
        default: 'new',
      },
      auditStatus: {
        type: String,
        default: '',
      },
      dialogVisible: {
        type: Boolean,
        default: false,
      },
      editData: {
        type: Object,
        default: () => {
          return {};
        },
      },
    },
    data() {
      return {
        formData: Object.assign({}, defaultFormData),
        previewData: Object.assign({}, defaultPreviewData),
        previewWatchField: {
          recordDateRange: [],
          advCompanyPlatform: null,
          advEntity: null,
        },
        rules: {
          advHedgeAmount: [{ required: true, trigger: 'blur' }],
          advCompanyPlatform: [{ required: true, trigger: 'blur' }],
          advEntity: [{ required: true, trigger: 'blur' }],
          recordDateRange: [{ required: true, trigger: 'blur' }],
          hyperTapEntityId: [{ required: true, trigger: 'blur' }],
          receiptStatus: [{ required: true, trigger: 'blur' }],
          currency: [{ required: true, trigger: 'blur' }],
          remark: [],
        },
        formProcessing: false,
      };
    },
    watch: {
      formData: {
        immediate: true,
        handler(val) {
          const { recordDateRange, advCompanyPlatform, advEntity } = val;
          // 值是否发生变化
          if (
            this.previewWatchField.advEntity === advEntity &&
            this.previewWatchField.advCompanyPlatform === advCompanyPlatform &&
            this.previewWatchField.recordDateRange.join(',') === recordDateRange.join(',')
          ) {
            return;
          }

          if (recordDateRange && recordDateRange.length > 0 && advCompanyPlatform && advEntity) {
            setTimeout(() => {
              if (
                recordDateRange &&
                recordDateRange.length > 0 &&
                advCompanyPlatform &&
                advEntity
              ) {
                this.handlePreview();
                this.previewWatchField = {
                  recordDateRange,
                  advCompanyPlatform,
                  advEntity,
                };
              }
            }, 500);
          }
        },
        deep: true,
      },
    },
    created() {},
    mounted() {},
    methods: {
      isNotBlank,
      handleFormProcessingEnd() {
        setTimeout(() => {
          this.formProcessing = false;
        }, 500);
      },
      handleSubmit() {
        this.$refs.baseForm.validate((valid) => {
          if (valid) {
            this.formProcessing = true;
            switch (this.dialogType) {
              case 'new':
                this.formData.hyperTapEntity = this.hyperTapCompanyEntities.find(
                  (item) => item.bfiId === this.formData.hyperTapEntityId
                ).companyEntity;
                addAdvHedgeApp({ ...this.formData })
                  .then(() => {
                    this.$message({
                      message: 'Add Success',
                      type: 'success',
                    });
                    this.$emit('refresh-list');
                    this.handleClose();
                  })
                  .finally(() => {
                    this.handleFormProcessingEnd();
                  });
                break;
              case 'status':
                if (this.auditStatus === 'AUTO_RECEIPT') {
                  advPaymentAutoReceiptProcess(this.formData.advHedgeAppNumber)
                    .then(() => {
                      this.$message({
                        message: 'Success',
                        type: 'success',
                      });
                      this.$emit('refresh-list');
                      this.handleClose();
                    })
                    .finally(() => {
                      this.handleFormProcessingEnd();
                    });
                } else {
                  auditAdvHedgeAppStatus({
                    advHedgeAppNumber: this.formData.advHedgeAppNumber,
                    auditRemark: this.formData.auditRemark,
                    auditStatus: this.auditStatus,
                  })
                    .then(() => {
                      this.$message({
                        message: 'Success',
                        type: 'success',
                      });
                      this.$emit('refresh-list');
                      this.handleClose();
                    })
                    .finally(() => {
                      this.handleFormProcessingEnd();
                    });
                }
                break;
            }
          } else {
            return false;
          }
        });
      },
      handleClose() {
        this.$emit('update:dialogVisible', false);
        this.$emit('update:auditStatus', null);
        this.$refs.baseForm.resetFields();
        this.formData = Object.assign({}, defaultFormData);
        this.previewData = Object.assign({}, defaultPreviewData);
        this.previewWatchField = {
          recordDateRange: [],
          advCompanyPlatform: null,
          advEntity: null,
        };
      },
      handlePreview() {
        if (
          this.formData.recordDateRange.length === 0 ||
          !this.formData.advCompanyPlatform ||
          !this.formData.advEntity
        ) {
          this.$message.error('请填写日期、公司平台、公司实体');
          return;
        }
        this.formProcessing = true;
        getAdvHedgeAppPreviewData({
          recordDateRange: this.formData.recordDateRange,
          advCompanyPlatform: this.formData.advCompanyPlatform,
          advEntity: this.formData.advEntity,
        })
          .then((res) => {
            if (res && res.result) {
              this.previewData = res.result;
            }
          })
          .finally(() => {
            setTimeout(() => {
              this.formProcessing = false;
            }, 500);
          });
      },
      /**
       * 计算 affHedgeAppNumber 和 advReceiptClaimNumberList 对应的金额
       */
      handleApplyHedgeAmount() {
        const affHedgeAppNumberList = this.formData.affHedgeAppNumberList;
        const advReceiptClaimNumberList = this.formData.advReceiptClaimNumberList;
        // 渠道抵扣金额
        let totalAffHedgeAmount = 0;
        if (!isArrayBlank(this.previewData.affHedgeAppItemList)) {
          this.previewData.affHedgeAppItemList.forEach((item) => {
            if (affHedgeAppNumberList.includes(item.affHedgeAppNumber)) {
              totalAffHedgeAmount += item.affHedgeAmount;
            }
          });
        }

        // 广告主预收款金额
        let totalAdvReceivedAmount = 0;
        if (!isArrayBlank(this.previewData.advPreReceiptAppItemList)) {
          this.previewData.advPreReceiptAppItemList.forEach((item) => {
            if (advReceiptClaimNumberList.includes(item.advReceiptClaimNumber)) {
              totalAdvReceivedAmount += item.financeReceivedAmount;
            }
          });
        }
        this.formData.applyHedgeAmount = totalAffHedgeAmount + totalAdvReceivedAmount;
      },
    },
  };
</script>

<template>
  <el-dialog
    :title="dialogType === 'new' ? 'Adv Hedge Application Create' : 'Adv Hedge Application Update'"
    :visible="dialogVisible"
    :close-on-click-modal="false"
    width="40%"
    @close="handleClose"
  >
    <el-alert
      v-show="isNotBlank(this.previewData.checkMessage) && this.auditStatus !== 'FINANCE_PAID'"
      :title="this.previewData.checkMessage"
      type="warning"
      show-icon
      :closable="false"
      style="margin-bottom: 20px"
    />
    <el-form
      label-position="left"
      label-width="200px"
      ref="baseForm"
      :model="formData"
      :rules="rules"
      :disabled="formProcessing"
    >
      <section v-if="dialogType === 'status'" class="grid-form-large">
        <el-form-item label="Adv Hedge App Number" prop="advHedgeAppNumber" required>
          <el-input v-model="formData.advHedgeAppNumber" placeholder="please input" />
        </el-form-item>
        <el-form-item
          label="Audit Remark "
          v-if="auditStatus !== 'AUTO_RECEIPT'"
          prop="auditRemark"
        >
          <el-input
            v-model="formData.auditRemark"
            type="textarea"
            show-word-limit
            maxlength="255"
            label-width="240px"
            placeholder="please input"
          />
        </el-form-item>
      </section>

      <section v-if="auditStatus === 'AUTO_RECEIPT'" class="grid-form-large">
        <el-form-item label="Adv Hedge App Number" prop="advHedgeAppNumber" required>
          <el-input v-model="formData.advHedgeAppNumber" placeholder="please input" />
        </el-form-item>
      </section>

      <section v-if="dialogType === 'new'" class="grid-form">
        <el-form-item label="Date" prop="recordDateRange">
          <el-date-picker
            v-model="formData.recordDateRange"
            format="yyyy-MM"
            value-format="yyyy-MM"
            type="monthrange"
            clearable
            align="right"
            unlink-panels
            style="width: 250px"
            range-separator="to"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          />
        </el-form-item>
        <el-form-item label="Adv Company Platform" prop="advCompanyPlatform">
          <el-select
            v-model="formData.advCompanyPlatform"
            filterable
            clearable
            @change="handleCompanyPlatformChange(formData.advCompanyPlatform)"
          >
            <el-option
              v-for="item in companyPlatformList"
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="Adv Entity" prop="advEntity">
          <el-select v-model="formData.advEntity" ref="companyEntityOptions" filterable clearable>
            <el-option
              v-for="item in specificCompanyEntity"
              :key="item.id"
              :label="item.companyEntity"
              :value="item.companyEntity"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="Aff Hedge App Number" prop="affHedgeAppNumberList">
          <el-select
            v-model="formData.affHedgeAppNumberList"
            multiple
            filterable
            clearable
            @change="handleApplyHedgeAmount"
          >
            <el-option
              v-for="(item, index) in previewData.affHedgeAppItemList"
              :key="index"
              :label="item.affHedgeAppNumber"
              :value="item.affHedgeAppNumber"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="Adv Receipt Claim Number" prop="advReceiptClaimNumberList">
          <el-select
            v-model="formData.advReceiptClaimNumberList"
            multiple
            filterable
            clearable
            @change="handleApplyHedgeAmount"
          >
            <el-option
              v-for="(item, index) in previewData.advPreReceiptAppItemList"
              :key="index"
              :label="item.advReceiptClaimNumber"
              :value="item.advReceiptClaimNumber"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="Adv Revenue">
          <el-input v-model="previewData.totalAdvRevenue" disabled />
        </el-form-item>
        <el-form-item label="Adv Confirmed Amount">
          <el-input v-model="previewData.totalAdvConfirmedAmount" disabled />
        </el-form-item>
        <el-form-item label="Adv Deduction Amount">
          <el-input v-model="previewData.totalAdvDeductionAmount" disabled />
        </el-form-item>
        <el-tooltip
          class="item"
          effect="dark"
          content="渠道抵扣金额 + 广告主预收款金额"
          placement="top"
        >
          <el-form-item label="Apply Hedge Amount" prop="applyHedgeAmount">
            <el-input type="number" v-model="formData.applyHedgeAmount" disabled />
          </el-form-item>
        </el-tooltip>
        <el-form-item label="Adv Hedge Amount" prop="advHedgeAmount">
          <el-input type="number" v-model="formData.advHedgeAmount" />
        </el-form-item>
        <el-form-item label="Receipt Status" prop="receiptStatus" required>
          <el-select v-model="formData.receiptStatus" filterable>
            <el-option
              v-for="item in advHedgeAppReceiptStatusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="HyperTap Entity" prop="hyperTapEntityId" required>
          <el-select
            v-model="formData.hyperTapEntityId"
            ref="hyperTapEntityOptions"
            filterable
            @change="handleHyperTapEntityChange(formData.hyperTapEntityId)"
          >
            <el-option
              v-for="item in hyperTapCompanyEntities"
              :key="item.bfiId"
              :label="
                isNotBlank(item.companyEntityAlias) ? item.companyEntityAlias : item.companyEntity
              "
              :value="item.bfiId"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="Remark" prop="remark">
          <el-input
            v-model="formData.remark"
            type="textarea"
            show-word-limit
            maxlength="255"
            placeholder="please input"
          />
        </el-form-item>
      </section>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" :loading="formProcessing" @click="handleSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<style scoped lang="scss"></style>
